<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1.table-cliente(:headers='headers' item-key='clientes' :items='clientes' :search='search' sort-by='nombre' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-flex(class="d-flex flex-wrap justify-center")
              v-toolbar-title Clientes
              v-divider.mx-4(inset vertical)
              v-text-field.text-xs-center.px-2(v-model='search' label='Búsqueda' single-line hide-details color='success')
              ClienteE.ma-1(:FormPadre="clientes" :origen='origen')
              v-btn.ma-1(color='success' dark @click='deudores' v-if="mostrarDeudores")
                | Deudores
              v-btn.ma-1(color='success' dark @click='clientesTotal' v-else)
                | Clientes
            v-btn.mx-2(v-if='validarCrear()' fab dark small color='success' @click='dialog = true' )
              v-icon(dark) mdi-plus
            ClienteM(:dialog='dialog' :editedIndex='editedIndex' @close='close' :read='read' :FormPadre='editedItem'  @edited='listarCliente' @save='listarCliente' :mostrar='mostrar')
            FacturaClienteM(:dialog='dialog2' @close='dialog2=false' @act='listarVenta' :FormPadre='clienteFac' :credito='credito' :facturas='clienteFac.facturas')
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item, true, true)' v-on="on") mdi-format-list-checkbox
            | Facturas Asociadas
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item, true, false)' v-on="on") mdi-eye
            | Visualizar
          v-tooltip(bottom v-if="validarModificar()")
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='warning' @click='editItem(item, false, false)' v-on="on") mdi-pencil
            | Editar
          v-tooltip(bottom v-if="validarEliminar()")
            template(v-slot:activator='{ on }')
              v-icon(color='error' @click='deleteItem(item)' v-on="on") mdi-delete
            | Eliminar
        template(v-slot:no-data)
          h1 No hay datos de Clientes Asociados
</template>

<script>
import Api from '@/services/methods'
import ClienteM from '@/components/modals/ClienteM'
import FacturaClienteM from '@/components/modals/FacturaClienteM'
import ClienteE from './excel/ClienteE'
export default {
  data: () => ({
    mostrar: true,
    dialog: false,
    dialog2: false,
    // dialog3: false,
    read: false,
    loading: true,
    mostrarDeudores: true,
    mostrarAccion: false,
    origen: 'client',

    credito: 0,
    headers: [
      { text: 'Nombre', value: 'nombre', align: 'center', sortable: false },
      { text: 'Rif', align: 'center', value: 'rif' },
      { text: 'Contribuyente', align: 'center', value: 'contribuyente' },
      { text: 'Canal', align: 'center', value: 'canal' },
      { text: 'Sub-Canal', align: 'center', value: 'subcanal' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    dataForExcel: [
      { colA: 'Hello', colB: 'World' },
      { colA: 'Multi-line', colB: 'This is a long' },
      { colA: 'Another', colB: 'Regular cell' }
    ],

    clientes: [],
    clientesRes: [],
    clientesDeudores: [],
    clientesDe: [],
    cxc: [],
    cxcDeudores: [],
    clienteTemporal: {},
    ventas: [],
    permisosRuta: {},
    search: '',
    editedIndex: -1,
    editedIndex2: -1,
    editedItem: {},
    defaultItem: {},
    clienteFac: {
      nombre: '',
      rif: '',
      direccion: '',
      telefonos: '',
      telefono: '',
      idRuta: '',
      contribuyente: '',
      idTipoCliente: '',
      canal: '',
      subcanal: '',
      // atencion: '',
      codEstado: '',
      codMunicipio: '',
      codParroquia: '',
      correo: ''
      // representante1: '',
      // representante2: '',
      // correo1: '',
      // correo2: '',
      // telefono1: '',
      // telefono2: '',
      // diasVisitas: '',
      // frecuencia: ''
    }
  }),

  components: {
    ClienteM,
    FacturaClienteM,
    ClienteE
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
    this.permisosRuta = this.$store.state.empresa[0].permisos.find(
      permiso => permiso.ruta === 'Cliente'
    )
  },

  methods: {
    initialize () {
      this.listarCliente()
      this.listarVenta()
      this.listarCuentasXCobrar()
      this.editedIndex = -1
    },
    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD, HH:mm')
    },
    forma1 (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD')
    },
    forma2 (fecha) {
      return this.$moment(fecha).format('DD-MM-YYYY')
    },
    decimal (val) {
      return Number.parseFloat(val).toFixed(2)
    },
    validarCrear () {
      return this.permisosRuta?.accion.includes('Crear')
    },
    validarModificar () {
      return this.permisosRuta?.accion.includes('Modificar')
    },
    validarEliminar () {
      return this.permisosRuta?.accion.includes('Eliminar')
    },
    listarCliente (clientes) {
      Api.get('/cliente')
        .then(response => {
          this.clientes = response.data
          this.clientesRes = response.data
          this.clientes.map(data => {
            data.fechaCreacion = this.formato(data.fechaCreacion)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarCuentasXCobrar () {
      Api.get('cuentaporcobrar')
        .then(response => {
          this.cxc = response.data
          // this.clientesCXC(response.data)
          let hoy = new Date()
          let moroso
          this.cxc.map((data, i) => {
            if (data.debito === 0) {
              this.cxc[i].estatusPago = 'Cancelada'
            } else {
              this.cxc[i].estatusPago = 'Pendiente'
            }
            data.fechaRegistro = this.formato(data.fechaRegistro)
            data.fechaVencimiento = this.formato(data.fechaVencimiento)
            data.fechaCierreFactura = this.formato(data.fechaCierreFactura)
            let fecha = this.$moment(hoy)
            let fecha2 = this.$moment(data.fechaVencimiento)
            moroso = fecha.diff(fecha2, 'days')
            if (moroso <= 0) this.cxc[i].moroso = 0
            else this.cxc[i].moroso = moroso
            data.debito = this.decimal(data.debito)
            data.credito = this.decimal(data.credito)
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    /* clientesCXC (cxc) {
      cxc.map(data => {
        if (this.clientes.length === 0) {
          this.clientes.push(data.idCliente)
        } else {
          let bool = false
          for (let i = 0; i < this.clientes.length; i++) {
            if (data.idCliente._id !== this.clientes[i]._id) {
              bool = true
            } else {
              bool = false
              break
            }
          }
          if (bool) {
            this.clientes.push(data.idCliente)
          }
        }
      })
    }, */

    listarVenta () {
      Api.get('/venta')
        .then(response => {
          this.ventas = response.data
          var hoy = new Date()
          let moroso
          this.ventas.map((data, i) => {
            var fechaV = this.forma1(data.fechaVencimiento)
            var fecha = this.$moment(hoy)
            var fecha2 = this.$moment(fechaV)
            moroso = fecha.diff(fecha2, 'days')

            if (moroso <= 0) this.ventas[i].moroso = 0
            else this.ventas[i].moroso = moroso

            data.fechaVencimiento = this.forma2(data.fechaVencimiento)
            data.fechaCreacion = this.forma2(data.fechaCreacion)
          })
          this.loading = false
          if (this.clienteTemporal) this.clienteFactura(this.clienteTemporal)
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    clienteFactura (cliente) {
      this.clienteTemporal = cliente
      this.credito = 0
      let fac = []
      this.clienteFac = cliente
      this.ventas.map(data => {
        if (data.idPedido && data.idPedido.idCliente) {  
          if (cliente._id === data.idPedido.idCliente._id) {
            fac.push(data)
            this.credito += data.credito
          }
        }
      })
      this.clienteFac.facturas = fac
    },

    deudores () {
      if (this.mostrarDeudores === true) {
        this.clientes = []
        this.clientesDeudores = []

        for (let i = 0; i < this.cxc.length; i++) {
          if (this.cxc[i].moroso > 0) {
            this.cxcDeudores.push(this.cxc[i])
          }
        }

        for (let i = 0; i < this.clientesRes.length; i++) {
          for (let j = 0; j < this.cxcDeudores.length; j++) {
            if (this.clientesRes[i]._id === this.cxcDeudores[j].idCliente._id) {
              this.clientesDe.push(this.clientesRes[i])
            }
          }
        }

        for (let m = 0; m < this.clientesDe.length; m++) {
          if (this.clientesDeudores.length === 0) {
            this.clientesDeudores.push(this.clientesDe[m])
          } else {
            let bool = false
            for (let n = 0; n < this.clientesDeudores.length; n++) {
              if (this.clientesDeudores[n]._id !== this.clientesDe[m]._id) {
                bool = true
              } else {
                bool = false
                break
              }
            }
            if (bool === true) {
              this.clientesDeudores.push(this.clientesDe[m])
            }
          }
        }

        for (let i = 0; i < this.clientesDeudores.length; i++) {
          this.clientes.push(this.clientesDeudores[i])
        }
      }
      this.mostrarDeudores = false
    },

    clientesTotal () {
      if (this.mostrarDeudores === false) {
        this.clientes = []
        this.clientesDeudores = []

        for (let i = 0; i < this.clientesRes.length; i++) {
          this.clientes.push(this.clientesRes[i])
        }
      }
      this.mostrarDeudores = true
    },

    editItem (item, bool, fac) {
      if (fac) {
        this.clienteFactura(item)
        this.dialog2 = true
      } else {
        this.editedIndex = this.clientes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.read = bool

        if (item.codigoSunagro === '' && bool === true) {
          this.mostrar = false
        } else if (item.codigoSunagro !== '' && bool === true) {
          this.mostrar = true
        }

        if (bool === false) {
          this.mostrar = true
        }
      }
    },

    deleteItem (item) {
      const index = this.clientes.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.clientes.splice(index, 1)
          Api.put('/cliente/deletelog/' + item._id).then(response => {
          })
        }
      })
    },
    close () {
      this.dialog = false
      // this.clientesDeudores = []
      setTimeout(() => {
        // this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
        this.clienteTemporal = {}
      }, 300)
    },
    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    save () {
    }
  }
}
</script>

<style lang="scss">
.table-cliente {
  header {
    height: auto !important;
    .v-toolbar__content {
      height: auto !important;
    }
  }
}
</style>
